import React, { useState } from 'react';
import Form from 'screens/shared/form';
import Icon from 'screens/shared/icon';
import { Paper, Collapse } from '@mui/material';
import CardBasic from 'screens/shared/card-basic';
import { VALIDATION } from 'constant';
import { _t } from 'utils';

export default ({
  onAdd,
  items: cdRoms = [],
  onEdit,
  selectToEdit,
  selectToDelete,
  deselectToEdit,
  isLimitExceeded,
}) => {
  const cdRom = {
    image: '',
  };

  const [openCreateForm, setOpenCreateForm] = useState(false);

  const cdRomFields = [
    {
      name: 'image',
      type: 'cdrom',
      style: { marginTop: 15 },
    },
  ];

  const validations = [
    {
      name: 'image',
      type: VALIDATION.REQUIRED,
    },
  ];

  const onSave = ({ id = null, ...item }) => {
    if (id) {
      return onEdit({ ...item, id });
    }

    onAdd(item);
    return setOpenCreateForm(false);
  };

  return (
    <div className="add-box">
      <h3 className="screen-create-server-title">
        {_t('CD-ROMs')}
        {' '}
        {isLimitExceeded && (
          <span className="circle-button" onClick={() => setOpenCreateForm((s) => !s)}>
            <Icon name="plus" />
            {_t('Add')}
          </span>
        )}
      </h3>
      <Collapse in={openCreateForm} collapsedSize="0px">
        <Paper style={{ marginTop: 20 }}>
          {openCreateForm && (
            <Form
              fields={cdRomFields}
              fieldsValues={cdRom}
              onSubmit={onSave}
              onCancel={() => setOpenCreateForm(false)}
              validations={validations}
            />
          )}
        </Paper>
      </Collapse>

      <div className="cards">
        {cdRoms.map(({ id, image, isEdit = false }) => {
          const {
            name, size,
          } = image;
          return (
            <div key={id}>
              <Collapse in={isEdit} collapsedSize="0px">
                <Paper style={{ marginTop: 20 }}>
                  {isEdit && (
                    <Form
                      fields={cdRomFields}
                      fieldsValues={{ id, image }}
                      onSubmit={onSave}
                      onCancel={() => deselectToEdit(id)}
                      validations={validations}
                    />
                  )}
                </Paper>
              </Collapse>
              {!isEdit && (
                <CardBasic
                  icon="compact-disc"
                  details={`${size} GB`}
                  title={<span style={{ fontSize: 15 }}>{name}</span>}
                  actionButtons={{
                    edit: () => selectToEdit(id),
                    delete: () => selectToDelete(id),
                  }}
                />
              )}
            </div>
          );
        }).reverse()}
      </div>
    </div>
  );
};
